import { apiPost, notifySuccess } from "@redriver/cinnamon";

const ActionTypes = {
  IpsPhysicalApproval: "SHEETS/IPS_PHYSICAL_APPROVAL",
};

export const setIpsPhysicalApproval = ({ sheetId }) =>
  apiPost(
    ActionTypes.IpsPhysicalApproval,
    `sheets/${sheetId}/ips-physical-approval`,
  );
